<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<ng-container *ngIf="invite">

  <mat-card>
    <mat-card-header>
      Invite for {{invite.inviteEmail }}
    </mat-card-header>
    <mat-card-content>
      <div>
      <a href="/wallet-onboarding/start/{{invite.linkToken}}">
        Invite Form Link
      </a>
      </div>

      <div *ngIf="invite.applicant">
        <h4>Applicant</h4>
        {{invite.applicant.firstName}} {{invite.applicant.lastName}}<br />
        DOB:{{invite.applicant.dob}}
      </div>

    </mat-card-content>
  </mat-card>

</ng-container>
